import { isArray } from 'lodash';
import * as types from '../constants/dashboardConstants';
const initialState = {
  loading: false,
  loaded: false,
  sessionTimeOut: false,
  changeLayoutFlag: 0,
  canLogout: false,
  settingmodal: false,
  updatedAccBal: [],
  defAcc: {},
  BMModel: false,
  LMTModel: false,
  addWidgetmodal: true,
  enableflag: false,
  //isTrdInstant:null
  loadTempFlag: false,
  trdBookRandomNo: 0,
  toolTipFlag: true,
  deletewidgetflag: false,
  cmdtyRandomNo: 0,
  deleteTempRandomNo: 0,
  lmtOrdComponentFlag: false,
  bmkComponentFlag: false,
  saveTemplateFlag: false,
  fontsize: '',
  isInitialApiLoaded: false,
  modalName: '',
  trdColumns: [],
  isDefAccChngeFlag: false,
};
//To make widgets not editable on initial fetch
const setWidgetStatic = (layout) => {
  layout.map(item => {
    item.static = false;
  });
  return layout;
};
const setComdtyPair = (layout, cmdtyPair) => {
  layout.map((item) => {
    let str = item.name;
    if (str === "Trade") {
      if (!item.cmdtyPair) {
        const tco = JSON.parse(localStorage.getItem('TS')).TCO;
        item.cmdyPair = tco[0];
      }
    }
  });
  return layout;
};
const getEdittedLayout = (layout) => {
  layout.map((item) => {
    let str = item.i;
    const url = str.split('-', 3);
    const cmdtyPair1 = url[url.length - 2];
    const cmdtyPair2 = url[url.length - 1];
    const cmdtyPairCombined = cmdtyPair1 + '-' + cmdtyPair2;
    str = str.substring(0, str.indexOf('-'));
    switch (str) {
      case 'Instrument':
        if (item.w < 8 || item.h < 7) {
          item.w = 8;
          item.h = 8;
        }
        item.name = 'instrumentList';
        break;
      case 'Margin':
        item.name = 'Margin';
        break;
      case 'Trade':
        item.name = 'Trade';
        item.w = 5;
        item.h = 8;
        if (item.cmdtyPair === "") {
          const tco = JSON.parse(localStorage.getItem('TS')).TCO;
          item.cmdtyPair = tco[0];
        }
        if (item.selectedTabKey !== undefined) {
          item.selectedTabKey = item.selectedTabKey;
        }
        break;
      case 'OutstandingOrder':
        if (item.w < 2 || item.h < 2) {
          item.w = 24;
          item.h = 8;
        }
        item.minW = 15;
        item.name = 'OutstandingOrder';
        break;
      case 'TrackBook':
        item.name = 'TrackBook';
        break;
      case 'ActivityLog':
        if (item.w < 2 || item.h < 2) {
          item.w = 24;
          item.h = 8;
        }
        item.name = 'ActivityLog';
        break;
      case 'NewsFeed':
        item.name = 'NewsFeed';
        break;
      case 'Chart':
        if (item.w < 2 || item.h < 2) {
          item.w = 12;
          item.h = 12;
          item.minW = 12;
          item.maxW = 100;
          item.minH = 12;
          item.maxH = 100;
        }
        if (item.cmdtyPair === undefined) {
          const tco = JSON.parse(localStorage.getItem('TS')).TCO;
          item.cmdtyPair = tco[0];
        }
        if (item.chartData === undefined) {
          item.chartData = [{ 'dataType': 'Live', 'graphType': 'Line', 'category': 'Ask', 'duration': 'Minute', 'histGraphType': 'Line' }]
        }
        item.name = 'Chart';
        break;
      case 'PaymentRequest':
        if (item.w < 2 || item.h < 2) {
          item.w = 24;
          item.h = 8;
        }
        item.name = 'PaymentRequest';
        break;
      case 'SwapRates':
        item.w = 5;
        item.h = 8;
        item.name = 'SwapRates';
        break;

      default:
        break;
    }
  });
  return layout;
};

const appendDeletkey = (deletionWidgetsKey, keyValue) => {
  deletionWidgetsKey.push(keyValue);
  return deletionWidgetsKey;
};

const addWidgetSample = (widgetName, layoutAdd) => {
  let idName;
  let name;
  let width;
  let minWidth;
  let maxWidth;
  let height;
  let maxHeight;
  let minHight;
  const tco = JSON.parse(localStorage.getItem('TS')).TCO;
  switch (widgetName) {
    case 'instrument':
      idName = 'Instrument-' + new Date();
      name = 'instrumentList';
      minWidth = 8;
      width = 8;
      maxWidth = 8;
      minHight = 7;
      maxHeight = 100;
      height = 8;
      break;
    case 'activityLog':
      idName = 'ActivityLog-' + new Date();
      name = 'ActivityLog';
      minWidth = 5;
      width = 24;
      maxWidth = 100;
      minHight = 5;
      maxHeight = 100;
      height = 8;
      break;
    case 'newsFeed':
      idName = 'NewsFeed-' + new Date();
      name = 'NewsFeed';
      minWidth = 5;
      width = 5;
      maxWidth = 100;
      minHight = 5;
      maxHeight = 100;
      height = 8;
      break;
    case 'trade':
      idName = 'Trade-' + tco[0] + '-' + new Date();
      name = 'Trade';
      minWidth = 5;
      width = 5;
      maxWidth = 5;
      minHight = 8;
      height = 8;
      maxHeight = 8;
      break;
    case 'chart':
      idName = 'Chart-' + new Date();
      name = 'Chart';
      minWidth = 12;
      width = 12;
      maxWidth = 100;
      minHight = 12;
      maxHeight = 100;
      height = 12;
      break;
    case 'margin':
      idName = 'Margin-' + new Date();
      name = 'Margin';
      minWidth = 5;
      width = 5;
      maxWidth = 100;
      minHight = 5;
      maxHeight = 100;
      height = 8;
      break;
    case 'outstandingOrder':
      idName = 'OutstandingOrder-' + new Date();
      name = 'OutstandingOrder';
      minWidth = 15;
      width = 24;
      maxWidth = 100;
      minHight = 8;
      maxHeight = 100;
      height = 8;
      break;
    case 'PaymentRequest':
      idName = 'PaymentRequest-' + new Date();
      name = 'PaymentRequest';
      minWidth = 8;
      width = 24;
      maxWidth = 100;
      minHight = 8;
      maxHeight = 100;
      height = 8;
      break;
    case 'SwapRates':
      idName = 'SwapRates-' + new Date();
      name = 'SwapRates';
      minWidth = 5;
      width = 5;
      maxWidth = 5;
      minHight = 8;
      height = 8;
      maxHeight = 8;
      break;
    default:
      break;
  }
  const obj = { w: width, h: height, x: 0, y: 29, i: idName, minW: minWidth, maxW: maxWidth, minH: minHight, maxH: maxHeight, static: false, name: name };
  if (widgetName === 'trade' || widgetName === 'Chart') {
    const tco = JSON.parse(localStorage.getItem('TS')).TCO;
    obj.cmdtyPair = tco[0];
  }
  const dataObj = [{ 'dataType': 'Live', 'graphType': 'Line', 'category': 'Ask', 'duration': 'Minute', 'histGraphType': 'Line' }];
  if (widgetName === 'Chart') {
    obj.chartData = dataObj;
  }
  layoutAdd.push(obj);
  return layoutAdd;
};

const setFontSize = () => {
  const trdData = JSON.parse(localStorage.getItem('TS'));
  if (trdData.isSmallerfont === true) {
    localStorage.setItem('fontsize', 'smallerfont');
    return "smallerfont";
  }
  else if (trdData.isBiggerfont === true) {
    localStorage.setItem('fontsize', 'biggerfont');
    return "biggerfont";
  }
  else {
    localStorage.setItem('fontsize', 'normalfont');
    return "normalfont";
  }
}

// const isWidgetDeletedInEditMode = (layout, deleteWidgetKey) => {
//   if (deleteWidgetKey) {
//     deleteWidgetKey.forEach((item) => {
//       layout.forEach((element, index) => {
//         if (item === element.i) {
//           layout.splice(index, 1);
//         }
//       });
//     });
//   }
//   return layout;
// };
const isSessionTimeOut = (statusCode) => {
  if (statusCode === 401) {
    // localStorage.setItem('user', null);
    return true;
  }
  return false;
};
const isISerror = (statusCode) => {
  if (statusCode === 500) {
    return true;
  }
  return false;
};
const gettemplist = (templatesList) => {
  return templatesList.map((item, index) => {
    return {
      ...item,
      templ: item.N
    };
  });
};

const changeId = (cmdyPair, currentId, layout, selectedTabKey) => {
  const newId = 'Trade-' + cmdyPair + '-' + new Date();
  layout.map((item) => {
    if (item.i === currentId) {
      item.i = newId;
      item.cmdtyPair = cmdyPair;
      item.selectedTabKey = selectedTabKey;
    }
  });
  return layout;
};
const changeChartOpts = (cmdyPair, currentId, layout, chartDataObj) => {
  layout.map((item) => {
    if (item.i === currentId) {
      item.cmdtyPair = cmdyPair;
      item.chartData = chartDataObj
    }
  });
  return layout;
};
const setDefaultAccount = (accMap) => {
  let obj = {};
  accMap.map(item => {
    if (item.DFA === "1") {
      obj = { 'AC': item.C, 'AD': item.D, 'isForward':item.isFwdEnable, 'isSwpEnable': item.isSwpEnable, 'maxTenor': item.maxTenor };
      localStorage.setItem('DefaultAC', JSON.stringify(obj));
    }
  })
  return obj;
}
const getTradebookCols = (trdCols) => {
	return trdCols.map((item) => {
		item.isColRearrange=(item.isColRearrange? item.isColRearrange : false)
		return {
			...item
		};
	});
}
const stockCodeobj = {
  "property": "stockCode", "props": { "style": { "width": "20%", "min-width": "105px" } },
  "visible": "true", "header": { "label": "Unit", "props": { "label": "Unit" } }
}
const eqOzObj = {
  "property": "eqOz", "props": { "style": { "width": "7%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" },
  "visible": "true", "header": { "label": "Eq. Oz", "props": { "label": "Eq. Oz" } }
}
const alignCss = { "style": { "width": "7%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };

// handle arrangement of Qty column for BMK
const arrangeQtyColumn = (column) => {
  if (column.findIndex(x => (x.property === 'quantity')) !== -1) {
    const qtyIndex = column.findIndex(x => (x.property == 'quantity'));
    column[qtyIndex].props = { "style": { "width": "13%", "min-width": "135px", "text-align": "right" }, "isNumber": " true" };
    column[qtyIndex].header = { "label": "Qty", "props": { "label": "Qty" } };
    const dealIndex = column.findIndex(x => (x.property === 'deal'))
    
    /**
     * check if other column is added 
     * between deal and qty, if no then
     * they should be kept one after the other 
     */ 
    let indirectReArrangement = false;
    if (!column[qtyIndex].isColRearrange && !column[dealIndex].isColRearrange) {
      for (let i = dealIndex + 1; i < qtyIndex; i++) {
        if (column[i].isColRearrange) {
          indirectReArrangement = true;
          break;
        }
      }
      if (!indirectReArrangement) {
        //Adding Quantity after Deal column
        column.splice(dealIndex + 1, 0, column[qtyIndex]);
        //Removing duplicate column Quantity
        column.splice(qtyIndex + 1, 1)
      }
    }
  }
  return column;
}

const removeSerialNoColumn = (columns) => {
  const serialNoIndex = columns.findIndex(x => x.property === 'srno');
  if (serialNoIndex !== -1) {
    columns.splice(serialNoIndex, 1);
  }
  return columns;
};


// get Outstanding Bmk Orders Columns
const getOutBMKCols =(trdcols)=>{
  let outBmCols = getTradebookCols(trdcols)
  outBmCols = removeSerialNoColumn(outBmCols);
  
  if (outBmCols.findIndex(x => (x.property == 'fixingDate')) === -1) {
    let eTimeIndex = outBmCols.findIndex(x => (x.property == 'eventTime'));
    let fixingObj = { "property": "fixingDate", "props": { "style": { "width": "9%", "min-width": "105px" } }, "visible": "true", 
                      "header": { "label": "Fixing Date", "props": { "label": "Fixing Date" } } }
    outBmCols.splice(eTimeIndex + 1, 0, fixingObj);
  }

  if (outBmCols.findIndex(x => (x.property == 'valDate')) === -1) {
    let valDateObj = { "property": "valDate", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", 
                        "header": { "label": "Value Date", "props": { "label": "Value Date" } } }
    outBmCols.splice(outBmCols.length + 1, 0, valDateObj);
  }
  if (outBmCols.findIndex(x => (x.property == 'spreadVal')) === -1) {
    let vdIndex = outBmCols.findIndex(x => (x.property == 'valDate'));
    let obj = { "property": "spreadVal", "props": { "style": { "width": "13%", "min-width": "105px", "text-align": "left" } }, "visible": "true", 
                "header": { "label": "Spread", "props": { "label": "Spread" } } }
    outBmCols.splice(vdIndex + 1, 0, obj);
  }
  if (outBmCols.findIndex(x => (x.property == 'forwardVal')) === -1) {
    let vdIndex = outBmCols.findIndex(x => (x.property == 'spreadVal'));
    let obj = {"property": "forwardVal", "props": { "style": { "width": "7%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" },"visible": "true", 
               "header": { "label": "Forward %", "props": { "label": "Forward %" } } }
    outBmCols.splice(vdIndex + 1, 0, obj);
  }
  
  outBmCols = arrangeQtyColumn(outBmCols);
  
  if (outBmCols.findIndex(x => (x.property == 'stockCode')) === -1) {
    let index = outBmCols.findIndex(x => (x.property == 'quantity'));
    outBmCols.splice(index + 1, 0, stockCodeobj);
  }
  if (outBmCols.findIndex(x => (x.property == 'eqOz')) === -1) {
    let index = outBmCols.findIndex(x => (x.property == 'stockCode'));
    outBmCols.splice(index + 1, 0, eqOzObj);
  }
  if (outBmCols.findIndex(x => (x.property === 'spreadVal')) !== -1) {
    let leftalignCss = { "style": { "width": "13%", "min-width": "105px", "text-align": "left" } };
    outBmCols[outBmCols.findIndex(x => (x.property === 'spreadVal'))].props = leftalignCss;
  }
  return outBmCols;
}

const getFillBMKCols=(trdCols)=>{
  let bmFilledcolumns = getTradebookCols(trdCols);
  bmFilledcolumns = arrangeQtyColumn(bmFilledcolumns);

  if (bmFilledcolumns.findIndex(x => (x.property == 'stockCode')) === -1) {
    let index = bmFilledcolumns.findIndex(x => (x.property == 'quantity'));
    bmFilledcolumns.splice(index + 1, 0, stockCodeobj);
  }
  if (bmFilledcolumns.findIndex(x => (x.property == 'eqOz')) === -1) {
    let index = bmFilledcolumns.findIndex(x => (x.property == 'stockCode'));
    bmFilledcolumns.splice(index + 1, 0, eqOzObj);
  }
  if (bmFilledcolumns.findIndex(x => (x.property === 'rate')) !== -1) {
    bmFilledcolumns[bmFilledcolumns.findIndex(x => (x.property === 'rate'))].props = alignCss;
  }
  return bmFilledcolumns;
}

const getAllBMKCols=(trdCols)=>{
  let bmOrderColumns = getTradebookCols(trdCols);
  bmOrderColumns = removeSerialNoColumn(bmOrderColumns);
  bmOrderColumns = arrangeQtyColumn(bmOrderColumns);
  if (bmOrderColumns.findIndex(x => (x.property == 'stockCode')) === -1) {
    let index = bmOrderColumns.findIndex(x => (x.property == 'quantity'));
    bmOrderColumns.splice(index + 1, 0, stockCodeobj);
  }
  if (bmOrderColumns.findIndex(x => (x.property == 'eqOz')) === -1) {
    let index = bmOrderColumns.findIndex(x => (x.property == 'stockCode'));
    bmOrderColumns.splice(index + 1, 0, eqOzObj);
  }

  if (bmOrderColumns.findIndex(x => (x.property === 'rate')) !== -1) {
    bmOrderColumns[bmOrderColumns.findIndex(x => (x.property === 'rate'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  return bmOrderColumns;
}

const getCancelBMKCols=(trdCols)=>{
  let bmCancelledOrdersColumns = getTradebookCols(trdCols);
  bmCancelledOrdersColumns = arrangeQtyColumn(bmCancelledOrdersColumns);
  
  if (bmCancelledOrdersColumns.findIndex(x => (x.property == 'stockCode')) === -1) {
    let index = bmCancelledOrdersColumns.findIndex(x => (x.property == 'quantity'));
    bmCancelledOrdersColumns.splice(index + 1, 0, stockCodeobj);
  }
  if (bmCancelledOrdersColumns.findIndex(x => (x.property == 'eqOz')) === -1) {
    let index = bmCancelledOrdersColumns.findIndex(x => (x.property == 'stockCode'));
    bmCancelledOrdersColumns.splice(index + 1, 0, eqOzObj);
  }
  return bmCancelledOrdersColumns;  
}

const getLMTFillCols=(trdCols)=>{
  let orderFilledcolumns = trdCols;
  if (orderFilledcolumns.findIndex(x => (x.property === 'quantity')) !== -1) {
    orderFilledcolumns[orderFilledcolumns.findIndex(x => (x.property === 'quantity'))].props = alignCss;
  }
  if (orderFilledcolumns.findIndex(x => (x.property === 'rate')) !== -1) {
    orderFilledcolumns[orderFilledcolumns.findIndex(x => (x.property === 'rate'))].props = alignCss;
  }
  if (orderFilledcolumns.findIndex(x => (x.property == 'dealType')) === -1) {
    let dealIndex = orderFilledcolumns.findIndex(x => (x.property == 'deal'));
    let typeObj = { "property": "dealType", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", 
                  "header": { "label": "Type", "props": { "label": "Type" } } }
    orderFilledcolumns.splice(dealIndex, 0, typeObj);
  }
  if (orderFilledcolumns.findIndex(x => (x.property === 'validity')) !== -1) {
    orderFilledcolumns[orderFilledcolumns.findIndex(x => (x.property === 'validity'))].props = { "style": { "width": "7%", "min-width": "185px", "text-align": "right" }, "visible": "true" };
  }
  return orderFilledcolumns;
}

const getOutLMTCols=(trdCols)=>{
  let outstngLmtOrderColumns=trdCols

  outstngLmtOrderColumns = removeSerialNoColumn(outstngLmtOrderColumns);
  if (outstngLmtOrderColumns.findIndex(x => (x.property == 'dealType')) === -1) {
    let dealIndex = outstngLmtOrderColumns.findIndex(x => (x.property == 'deal'));
    let typeObj = { ...dealIndex, "property": "dealType", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", 
                  "header": { "label": "Type", "props": { "label": "Type" } } }
    outstngLmtOrderColumns.splice(dealIndex, 0, typeObj);
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'orderNo')) !== -1) {
    let obj = { 
      ...outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'orderNo'))],
      "property": "orderNo", 
      "props": { "style": { "width": "10%", "min-width": "105px" } }, 
      "header": { "label": "Order #", "props": { "label": "Order #" }, 
      "transforms": [null] }, 
      "cell": { "formatters": [null] } 
    }
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'orderNo'))] = obj;
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'quantity')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'quantity'))].props = alignCss;
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'price')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'price'))].props = alignCss;
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'working')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'working'))].props = alignCss;
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'filled')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'filled'))].props = alignCss;
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'proximity')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'proximity'))].props = { "style": { "width": "8%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property == 'cancelQty')) === -1) {
    let filledIndex = outstngLmtOrderColumns.findIndex(x => (x.property == 'filled'));
    let cancelQtyObj = { "property": "cancelQty", "props": { "style": { "width": "10%", "min-width": "110px", "text-align": "right" }, "isNumber": " true" }, "visible": "true",
                         "header": { "label": "Cancelled", "props": { "label": "Cancelled" } } }
    outstngLmtOrderColumns.splice(filledIndex + 1, 0, cancelQtyObj);
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property == 'valDate')) === -1) {
    let valDateObj = { "property": "valDate", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", 
                    "header": { "label": "Value Date", "props": { "label": "Value Date" } } }
    outstngLmtOrderColumns.splice(outstngLmtOrderColumns.length + 1, 0, valDateObj);
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property == 'forwardVal')) === -1) {
    let valIndex = outstngLmtOrderColumns.findIndex(x => (x.property == 'valDate'));
    let obj = {
      "property": "forwardVal", "props": { "style": { "width": "7%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" },
      "visible": "true", "header": { "label": "Forward %", "props": { "label": "Forward %" } }
    }
    outstngLmtOrderColumns.splice(valIndex + 1, 0, obj);
  }
  if (outstngLmtOrderColumns.findIndex(x => (x.property === 'validity')) !== -1) {
    outstngLmtOrderColumns[outstngLmtOrderColumns.findIndex(x => (x.property === 'validity'))].props = { "style": { "width": "7%", "min-width": "185px", "text-align": "right" }, "visible": "true" };
  }
  return outstngLmtOrderColumns;
}

// Cancel Orders cols
const getCancelLMTCols=(trdCols)=>{
  let cancelledOrderColumns = trdCols;
  if (cancelledOrderColumns.findIndex(x => (x.property === 'quantity')) !== -1) {
    cancelledOrderColumns[cancelledOrderColumns.findIndex(x => (x.property === 'quantity'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (cancelledOrderColumns.findIndex(x => (x.property === 'rate')) !== -1) {
    cancelledOrderColumns[cancelledOrderColumns.findIndex(x => (x.property === 'rate'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (cancelledOrderColumns.findIndex(x => (x.property == 'dealType')) === -1) {
    let dealIndex = cancelledOrderColumns.findIndex(x => (x.property == 'deal'));
    let typeObj = { "property": "dealType", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", "header": { "label": "Type", "props": { "label": "Type" } } }
    cancelledOrderColumns.splice(dealIndex, 0, typeObj);
  }
  if (cancelledOrderColumns.findIndex(x => (x.property === 'validity')) !== -1) {
    cancelledOrderColumns[cancelledOrderColumns.findIndex(x => (x.property === 'validity'))].props = { "style": { "width": "7%", "min-width": "185px", "text-align": "right" }, "visible": "true" };
  }
  return cancelledOrderColumns;   
}

const getExpLMTCols=(trdCols)=>{
  let expiredOrderColumns = trdCols;
  if (expiredOrderColumns.findIndex(x => (x.property === 'quantity')) !== -1) {
    expiredOrderColumns[expiredOrderColumns.findIndex(x => (x.property === 'quantity'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (expiredOrderColumns.findIndex(x => (x.property === 'rate')) !== -1) {
    expiredOrderColumns[expiredOrderColumns.findIndex(x => (x.property === 'rate'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (expiredOrderColumns.findIndex(x => (x.property == 'dealType')) === -1) {
    let dealIndex = expiredOrderColumns.findIndex(x => (x.property == 'deal'));
    let typeObj = {
      "property": "dealType",
      "props": { "style": { "width": "7%", "min-width": "105px" } },
      "visible": "true", "header": { "label": "Type", "props": { "label": "Type" } }
    }
    if (expiredOrderColumns.findIndex(x => (x.property === 'validity')) !== -1) {
      expiredOrderColumns[expiredOrderColumns.findIndex(x => (x.property === 'validity'))].props = { "style": { "width": "7%", "min-width": "185px", "text-align": "right" }, "visible": "true" };
    }
    expiredOrderColumns.splice(dealIndex, 0, typeObj);
  }
  return expiredOrderColumns;
}

const getAllLMTCols=(lmtOrderColumns)=>{
  let allLmtOrderColumns = lmtOrderColumns;

  allLmtOrderColumns = removeSerialNoColumn(allLmtOrderColumns);

  if (allLmtOrderColumns.findIndex(x => (x.property === 'quantity')) !== -1) {
    allLmtOrderColumns[allLmtOrderColumns.findIndex(x => (x.property === 'quantity'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (allLmtOrderColumns.findIndex(x => (x.property === 'rate')) !== -1) {
    allLmtOrderColumns[allLmtOrderColumns.findIndex(x => (x.property === 'rate'))].props = { "style": { "width": "13%", "min-width": "105px", "text-align": "right" }, "isNumber": " true" };
  }
  if (allLmtOrderColumns.findIndex(x => (x.property == 'dealType')) === -1) {
    let dealIndex = allLmtOrderColumns.findIndex(x => (x.property == 'deal'));
    let typeObj = { "property": "dealType", "props": { "style": { "width": "7%", "min-width": "105px" } }, "visible": "true", "header": { "label": "Type", "props": { "label": "Type" } } }
    allLmtOrderColumns.splice(dealIndex, 0, typeObj);
  }
  if (allLmtOrderColumns.findIndex(x => (x.property === 'validity')) !== -1) {
    allLmtOrderColumns[allLmtOrderColumns.findIndex(x => (x.property === 'validity'))].props = { "style": { "width": "7%", "min-width": "185px", "text-align": "right" }, "visible": "true" };
  }
  return allLmtOrderColumns;
}
const setLoadedLayout = (trdColumns) => {
  try {
  
    //Spot order
    let spotOrderCols = trdColumns.columns;
    if (spotOrderCols.findIndex(x => (x.property === 'quantity')) !== -1) {
      let index = spotOrderCols.findIndex(x => (x.property === 'quantity'));
      spotOrderCols[index].props = alignCss;
    }
    if (spotOrderCols.findIndex(x => (x.property === 'rate')) !== -1) {
      let index = spotOrderCols.findIndex(x => (x.property === 'rate'));
      spotOrderCols[index].props = alignCss;
    }
    trdColumns.columns = spotOrderCols;

    //get BMK Tab columns
    trdColumns.outstngBmOrderColumns= getOutBMKCols(trdColumns.outstngBmOrderColumns)
    trdColumns.bmFilledcolumns = getFillBMKCols(trdColumns.bmFilledcolumns)
    trdColumns.bmOrderColumns = getAllBMKCols(trdColumns.bmOrderColumns)
    trdColumns.bmCancelledOrdersColumns = getCancelBMKCols(trdColumns.bmCancelledOrdersColumns)

    //Limit orders
    trdColumns.orderFilledcolumns = getLMTFillCols(trdColumns.orderFilledcolumns)
    trdColumns.outstngLmtOrderColumns = getOutLMTCols(trdColumns.outstngLmtOrderColumns);
    trdColumns.cancelledOrderColumns = getCancelLMTCols(trdColumns.cancelledOrderColumns)
    trdColumns.expiredOrderColumns= getExpLMTCols(trdColumns.expiredOrderColumns)
    trdColumns.lmtOrderColumns = getAllLMTCols(trdColumns.lmtOrderColumns)



    //Avg BMK order
    if (isArray(trdColumns.avgBmkColumns) || !trdColumns.avgBmkColumns) {
      trdColumns.avgBmkColumns = {
        allAvgBmkColumns: [],
        workingAvgBmkColumns: [],
        closedAvgBmkColumns: []
      }
      
      let cols = [
        { visibleIndex: 0, dataField: "AVG", visible: true, caption: 'Order #', "header": { "label": "Order #", "props": { "label": "Order #" } }, width: '180px' },
        { visibleIndex: 1, dataField: "Cmdty Pair", visible: true, caption: 'Pair', "header": { "label": "Pair", "props": { "label": "Pair" } }, width: '100px' },
        { visibleIndex: 2, dataField: "Deal", visible: true, caption: 'Deal', "header": { "label": "Deal", "props": { "label": "Deal" } }, width: '90px' },
        { visibleIndex: 3, dataField: "Total Qty", visible: true, alignment: 'right', caption: 'Total Qty', "header": { "label": "Total Qty", "props": { "label": "Total Qty" } }, width: '125px' },
        { visibleIndex: 4, dataField: "Benchmark", visible: true, caption: 'Benchmark', "header": { "label": "Benchmark", "props": { "label": "Benchmark" } }, width: '135px' },
        { visibleIndex: 5, dataField: "Start Date", visible: true, caption: 'Start Date', "header": { "label": "Start Date", "props": { "label": "Start Date" } }, width: '130px' },
        { visibleIndex: 6, dataField: "End Date", visible: true, caption: 'End Date', "header": { "label": "End Date", "props": { "label": "End Date" } }, width: '130px' },
        { visibleIndex: 7, dataField: "Value Date", visible: true, caption: 'Value Date', "header": { "label": "Value Date", "props": { "label": "Value Date" } }, width: '130px' },
        { visibleIndex: 8, dataField: "Qty/Fix", visible: true, alignment: 'right', caption: 'Qty/Fix', "header": { "label": "Qty/Fix", "props": { "label": "Qty/Fix" } }, width: '100px' },
        { visibleIndex: 9, dataField: "Quantity Booked", visible: true, alignment: 'right', caption: 'Quantity Booked', "header": { "label": "Quantity Booked", "props": { "label": "Quantity Booked" } }, width: '200px' },
        { visibleIndex: 10, dataField: "Fixes Booked", visible: true, alignment: 'right', caption: 'Fixes Booked', "header": { "label": "Fixes Booked", "props": { "label": "Fixes Booked" } }, width: '130px' },
        { visibleIndex: 11, dataField: "Avg Price", visible: true, alignment: 'right', caption: 'Avg Price', "header": { "label": "Avg Price", "props": { "label": "Avg Price" } }, width: '125px' },
        { visibleIndex: 12, dataField: "Spread", visible: true, caption: 'Spread', "header": { "label": "Spread", "props": { "label": "Spread" } }, width: '200px' },
        { visibleIndex: 13, dataField: "Forward %", visible: true, alignment: 'right', caption: 'Forward %', "header": { "label": "Forward %", "props": { "label": "Forward %" } }, width: '125px' },
        { visibleIndex: 14, dataField: "Account", visible: true, caption: 'Account', "header": { "label": "Account", "props": { "label": "Account" } }, width: '200px' },
        { visibleIndex: 15, dataField: "Comments", visible: true, caption: 'Comments', "header": { "label": "Comments", "props": { "label": "Comments" } }, width: '200px' },
        { visibleIndex: 16, dataField: "Status", visible: true, caption: 'Status', "header": { "label": "Status", "props": { "label": "Status" } }, width: '120px' }
      ];
      let cols2 = [
        { visibleIndex: 0, dataField: "AVG", visible: true, caption: 'Order #', "header": { "label": "Order #", "props": { "label": "Order #" } }, width: '180px' },
        { visibleIndex: 1, dataField: "Cmdty Pair", visible: true, caption: 'Pair', "header": { "label": "Pair", "props": { "label": "Pair" } }, width: '100px' },
        { visibleIndex: 2, dataField: "Deal", visible: true, caption: 'Deal', "header": { "label": "Deal", "props": { "label": "Deal" } }, width: '90px' },
        { visibleIndex: 3, dataField: "Total Qty", visible: true, alignment: 'right', caption: 'Total Qty', "header": { "label": "Total Qty", "props": { "label": "Total Qty" } }, width: '125px' },
        { visibleIndex: 4, dataField: "Benchmark", visible: true, caption: 'Benchmark', "header": { "label": "Benchmark", "props": { "label": "Benchmark" } }, width: '135px' },
        { visibleIndex: 5, dataField: "Start Date", visible: true, caption: 'Start Date', "header": { "label": "Start Date", "props": { "label": "Start Date" } }, width: '130px' },
        { visibleIndex: 6, dataField: "End Date", visible: true, caption: 'End Date', "header": { "label": "End Date", "props": { "label": "End Date" } }, width: '130px' },
        { visibleIndex: 7, dataField: "Value Date", visible: true, caption: 'Value Date', "header": { "label": "Value Date", "props": { "label": "Value Date" } }, width: '130px' },
        { visibleIndex: 8, dataField: "Qty/Fix", visible: true, alignment: 'right', caption: 'Qty/Fix', "header": { "label": "Qty/Fix", "props": { "label": "Qty/Fix" } }, width: '100px' },
        { visibleIndex: 9, dataField: "Quantity Booked", visible: true, alignment: 'right', caption: 'Quantity Booked', "header": { "label": "Quantity Booked", "props": { "label": "Quantity Booked" } }, width: '200px' },
        { visibleIndex: 10, dataField: "Fixes Booked", visible: true, alignment: 'right', caption: 'Fixes Booked', "header": { "label": "Fixes Booked", "props": { "label": "Fixes Booked" } }, width: '130px' },
        { visibleIndex: 11, dataField: "Avg Price", visible: true, alignment: 'right', caption: 'Avg Price', "header": { "label": "Avg Price", "props": { "label": "Avg Price" } }, width: '125px' },
        { visibleIndex: 12, dataField: "Spread", visible: true, caption: 'Spread', "header": { "label": "Spread", "props": { "label": "Spread" } }, width: '200px' },
        { visibleIndex: 13, dataField: "Forward %", visible: true, alignment: 'right', caption: 'Forward %', "header": { "label": "Forward %", "props": { "label": "Forward %" } }, width: '125px' },
        { visibleIndex: 14, dataField: "Account", visible: true, caption: 'Account', "header": { "label": "Account", "props": { "label": "Account" } }, width: '200px' },
        { visibleIndex: 15, dataField: "Comments", visible: true, caption: 'Comments', "header": { "label": "Comments", "props": { "label": "Comments" } }, width: '200px' },
        { visibleIndex: 16, dataField: "Status", visible: true, caption: 'Status', "header": { "label": "Status", "props": { "label": "Status" } }, width: '120px' },
        { visibleIndex: 17, dataField: "SR", visible: false, caption: 'SR', "header": { "label": "SR", "props": { "label": "SR" } }, width: '120px' }

      ];
      let cols3 = [
        { visibleIndex: 0, dataField: "AVG", visible: true, caption: 'Order #', "header": { "label": "Order #", "props": { "label": "Order #" } }, width: '180px' },
        { visibleIndex: 1, dataField: "Cmdty Pair", visible: true, caption: 'Pair', "header": { "label": "Pair", "props": { "label": "Pair" } }, width: '100px' },
        { visibleIndex: 2, dataField: "Deal", visible: true, caption: 'Deal', "header": { "label": "Deal", "props": { "label": "Deal" } }, width: '90px' },
        { visibleIndex: 3, dataField: "Total Qty", visible: true, alignment: 'right', caption: 'Total Qty', "header": { "label": "Total Qty", "props": { "label": "Total Qty" } }, width: '125px' },
        { visibleIndex: 4, dataField: "Benchmark", visible: true, caption: 'Benchmark', "header": { "label": "Benchmark", "props": { "label": "Benchmark" } }, width: '135px' },
        { visibleIndex: 5, dataField: "Start Date", visible: true, caption: 'Start Date', "header": { "label": "Start Date", "props": { "label": "Start Date" } }, width: '130px' },
        { visibleIndex: 6, dataField: "End Date", visible: true, caption: 'End Date', "header": { "label": "End Date", "props": { "label": "End Date" } }, width: '130px' },
        { visibleIndex: 7, dataField: "Value Date", visible: true, caption: 'Value Date', "header": { "label": "Value Date", "props": { "label": "Value Date" } }, width: '130px' },
        { visibleIndex: 8, dataField: "Qty/Fix", visible: true, alignment: 'right', caption: 'Qty/Fix', "header": { "label": "Qty/Fix", "props": { "label": "Qty/Fix" } }, width: '100px' },
        { visibleIndex: 9, dataField: "Quantity Booked", visible: true, alignment: 'right', caption: 'Quantity Booked', "header": { "label": "Quantity Booked", "props": { "label": "Quantity Booked" } }, width: '200px' },
        { visibleIndex: 10, dataField: "Fixes Booked", visible: true, alignment: 'right', caption: 'Fixes Booked', "header": { "label": "Fixes Booked", "props": { "label": "Fixes Booked" } }, width: '130px' },
        { visibleIndex: 11, dataField: "Avg Price", visible: true, alignment: 'right', caption: 'Avg Price', "header": { "label": "Avg Price", "props": { "label": "Avg Price" } }, width: '125px' },
        { visibleIndex: 12, dataField: "Spread", visible: true, caption: 'Spread', "header": { "label": "Spread", "props": { "label": "Spread" } }, width: '200px' },
        { visibleIndex: 13, dataField: "Forward %", visible: true, alignment: 'right', caption: 'Forward %', "header": { "label": "Forward %", "props": { "label": "Forward %" } }, width: '125px' },
        { visibleIndex: 14, dataField: "Account", visible: true, caption: 'Account', "header": { "label": "Account", "props": { "label": "Account" } }, width: '200px' },
        { visibleIndex: 15, dataField: "Comments", visible: true, caption: 'Comments', "header": { "label": "Comments", "props": { "label": "Comments" } }, width: '200px' },
        { visibleIndex: 16, dataField: "Status", visible: true, caption: 'Status', "header": { "label": "Status", "props": { "label": "Status" } }, width: '120px' },
        { visibleIndex: 17, dataField: "SR", visible: false, caption: 'SR', "header": { "label": "SR", "props": { "label": "SR" } }, width: '10px' },
        { visibleIndex: 18, dataField: "PR", visible: false, caption: 'PR', "header": { "label": "PR", "props": { "label": "PR" } }, width: '20px' }
      ];
      trdColumns.avgBmkColumns.workingAvgBmkColumns = cols;
      trdColumns.avgBmkColumns.allAvgBmkColumns = cols2;
      trdColumns.avgBmkColumns.closedAvgBmkColumns = cols3;
    }

    // swap deals

    if (!Array.isArray(trdColumns.swapColumns) || trdColumns.swapColumns.length === 0) {
      trdColumns.swapColumns = cols;

      let cols = [{
          property: "eventTime",
          props: { style: { width: "13%", "min-width": "200px" } },
          visible: true,
          header: {
            label: "Event Time",
            props: { label: "Event Time" },
            transforms: [null]
          },
          dataField: "eventTime",
          visibleIndex: 0,
          caption: "Event Time",
          alignment: "left",
          width: "200px",
          name: "eventTime"
        },
        {
          property: "deal",
          props: { style: { width: "7%", "min-width": "90px" } },
          visible: true,
          header: {
            label: "Deal",
            props: { label: "Deal" },
            transforms: [null]
          },
          dataField: "deal",
          visibleIndex: 1,
          caption: "Deal",
          alignment: "left",
          width: "90px",
          name: "deal"
        },
        {
          property: "cmdtyPair",
          props: { style: { width: "7%", "min-width": "100px" } },
          visible: true,
          header: {
            label: "Pair",
            props: { label: "Pair" },
            transforms: [null]
          },
          dataField: "cmdtyPair",
          visibleIndex: 2,
          caption: "Pair",
          alignment: "left",
          width: "100px",
          name: "cmdtyPair"
        },
        {
          property: "quantity",
          props: {
            style: {
              width: "7%",
              "min-width": "125px",
              "text-align": "right"
            },
            isNumber: "true"
          },
          visible: true,
          header: {
            label: "Quantity",
            props: { label: "Quantity" },
            transforms: [null]
          },
          dataField: "quantity",
          visibleIndex: 3,
          caption: "Quantity",
          alignment: "right",
          width: "125px",
          name: "quantity"
        },
        {
          property: "qtyType",
          props: { style: { width: "7%", "min-width": "125px" } },
          visible: true,
          header: {
            label: "Qty Type",
            props: { label: "Qty Type" },
            transforms: [null]
          },
          dataField: "qtyType",
          visibleIndex: 4,
          caption: "Qty Type",
          alignment: "left",
          width: "125px",
          name: "qtyType"
        },
        {
          property: "nearLegRate",
          props: { style: { width: "7%", "min-width": "200px","text-align": "right" } , isNumber: "true" },
          visible: true,
          header: {
            label: "Near Leg Rate",
            props: { label: "Near Leg Rate" },
            transforms: [null]
          },
          dataField: "nearLegRate",
          visibleIndex: 5,
          caption: "Near Leg Rate",
          alignment: "right",
          width: "200px",
          name: "nearLegRate"
        },
        {
          property: "nearLegDate",
          props: { style: { width: "7%", "min-width": "220px" } },
          visible: true,
          header: {
            label: "Near Leg Value Date",
            props: { label: "Near Leg Value Date" },
            transforms: [null]
          },
          dataField: "nearLegDate",
          visibleIndex: 6,
          caption: "Near Leg Value Date",
          alignment: "left",
          width: "220px",
          name: "nearLegDate"
        },
        {
          property: "farLegRate",
          props: { style: { width: "7%", "min-width": "200px","text-align": "right" }, isNumber: "true" },
          visible: true,
          header: {
            label: "Far Leg Rate",
            props: { label: "Far Leg Rate" },
            transforms: [null]
          },
          dataField: "farLegRate",
          visibleIndex: 7,
          caption: "Far Leg Rate",
          alignment: "right",
          width: "200px",
          name: "farLegRate"
        },
        {
          property: "farLegDate",
          props: { style: { width: "7%", "min-width": "220px" } },
          visible: true,
          header: {
            label: "Far Leg Value Date",
            props: { label: "Far Leg Value Date" },
            transforms: [null]
          },
          dataField: "farLegDate",
          visibleIndex: 8,
          caption: "Far Leg Value Date",
          alignment: "left",
          width: "220px",
          name: "farLegDate"
        },
        {
          property: "docNo",
          props: { style: { width: "7%", "min-width": "105px" } },
          visible: true,
          header: {
            label: "Doc #",
            props: { label: "Doc #" },
            transforms: [null]
          },
          dataField: "docNo",
          visibleIndex: 9,
          caption: "Doc #",
          alignment: "right",
          width: "105px",
          name: "docNo"
        },
        {
          property: "trader",
          props: { style: { width: "13%", "min-width": "200px" } },
          visible: true,
          header: {
            label: "Trader",
            props: { label: "Trader" },
            transforms: [null]
          },
          dataField: "trader",
          visibleIndex: 10,
          caption: "Trader",
          alignment: "left",
          width: "200px",
          name: "trader"
        },
        {
          property: "accDescription",
          props: { style: { width: "13%", "min-width": "200px" } },
          visible: true,
          header: {
            label: "Account",
            props: { label: "Account" },
            transforms: [null]
          },
          dataField: "accDescription",
          visibleIndex: 11,
          caption: "Account",
          alignment: "left",
          width: "200px",
          name: "accDescription"
        },
        {
          property: "comments",
          props: {
            style: {
              width: "25%",
              "padding-right": 10
            }
          },
          visible: true,
          header: {
            label: "Comments",
            props: { label: "Comments" },
            transforms: [null]
          },
          dataField: "comments",
          visibleIndex: 12,
          caption: "Comments",
          alignment: "left",
          width: "200px",
          name: "comments"
        }
      ]
      
      trdColumns.swapColumns = cols;
    }


    localStorage.setItem('tradeBookColumns', JSON.stringify(trdColumns));
    localStorage.setItem('defaultTradeBookColumns', JSON.stringify(trdColumns));
    return trdColumns;
  } catch (e) {
    console.log(" Exception setLoadedLayout " + e);
  }
}
const getLayoutDet = (templateDet) => {
  const accData = JSON.parse(localStorage.getItem('TS')).ACD;
  let SWPR = false;
  accData.map(item => {
    if (item.DFA === "1") {
      SWPR = item.SWPR;
    }
  })
  let swapRateIndex = templateDet.findIndex(x => (x.name == 'SwapRates'));
  if (swapRateIndex !== -1 && SWPR === false) {
    templateDet.splice(swapRateIndex, 1);
  }
  let OutstandingOrderIndex = templateDet.findIndex(x => (x.name == 'OutstandingOrder'));
  templateDet.forEach((d, i) => {
    if (OutstandingOrderIndex === i) {
      d.minH = 8
    }
    return d;
  })
  return templateDet;
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOAD_WIDGET:
      return {
        ...state
      };
    case types.LOAD_WIDGET_SUCCESS:
      localStorage.setItem('dealcnfrmsg', JSON.stringify({}));
      localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
      localStorage.setItem('ocoOrdMsg', JSON.stringify({}));
      localStorage.setItem('bmOrdcnfrmsg', JSON.stringify({}));
      localStorage.setItem('cmdtyArray', JSON.stringify([]));
      const trdData = JSON.parse(localStorage.getItem('TS'));
      return {
        ...state,
        dashboardWidgets: setWidgetStatic(action.result.data.tmplData),
        clickedEdit: false,
        sessionTimeOut: false,
        status: action.result.status,
        deleteWidgetKey: [],
        layout: getLayoutDet(action.result.data.tmplData),
        layoutWindow: getLayoutDet(action.result.data.tmplData),
        tradeBookColumns: setLoadedLayout(action.result.data.tradeBookData),
        isTrdInstant: trdData.isTrdInstant,
        storetradeqty: trdData.storetradeqty,
        showStockPrc: trdData.showStock,
        fontsize: setFontSize(),
        defAcc: setDefaultAccount(trdData.ACD)
      };
    case types.LOAD_WIDGET_FAILURE:
      return {
        ...state,
        sessionTimeOut: isSessionTimeOut(action.error.statusCode),
        showPopup: isSessionTimeOut(action.error.statusCode),
        internalServerError: isISerror(action.error.statusCode)
      };
    case types.SAVE_WIDGET_ACTIONS:
      return {
        ...state,
        saveTemplateFlag: false,
        modalName: false
      };
    case types.SAVE_WIDGET_ACTIONS_SUCCESS:
      return {
        ...state,
        //dashboardWidgets: isWidgetDeletedInEditMode(action.layout, state.deleteWidgetKey),
        sessionTimeOut: false,
        showPopup: false,
        internalServerError: false,
        deleteWidgetKey: [],
        tempList: gettemplist(action.result.data.N),
        trdBookRandomNo: action.initialState.randomNo,
        saveTemplateFlag: true,
        modalName: action.initialState.modal
      };
    case types.SAVE_WIDGET_ACTIONS_FAILURE:
      return {
        ...state,
        sessionTimeOut: isSessionTimeOut(action.error.statusCode),
        showPopup: isSessionTimeOut(action.error.statusCode),
        internalServerError: isISerror(action.error.statusCode),
        saveTemplateFlag: false,
        modalName: action.initialState.modal
      };
    case types.EDIT_DASHBOARD:
      return {
        ...state,
        dashboardWidgets: state.dashboardWidgets,
        clickedEdit: action.clickedEdit,
        deleteWidgetKey: []
      };
    case types.SUCCESS_CHANGE_WIDGETS:
      //Redmine bug no 44: Widgets could not be added in iPAd due to the foll condition.
      //Have commented it and checked on all browsers.
      //Restore and maximize working fine and not breaking the dashboard UI
      //Also widgets getting added
      //if(window.innerWidth >= 1300){
      return {
        ...state,
        layout: getEdittedLayout(action.layout),
        layoutWindow: getEdittedLayout(action.layout),
        dashboardWidgets: getEdittedLayout(action.layout),
        loadTempFlag: true,
        deletewidgetflag: true
      };
    /*} else{
      return {
      ...state,
      layout: getEdittedLayout(action.layout),
      dashboardWidgets: getEdittedLayout(action.layout),
      loadTempFlag:false
      };
    }*/

    case types.TOGGLE_COLUMN:
      return {
        ...state,
        tradeBookColumns: action.columns
      }

    case types.DEFAULT_COMMODITYPAIR:
      return {
        ...state,
        layout: setComdtyPair(action.layout, action.cmdtyPair),
        layoutWindow: setComdtyPair(action.layout, action.cmdtyPair)
      }
    case types.SUCCESS_DELETION:
      return {
        ...state,
        deleteWidgetKey: appendDeletkey(state.deleteWidgetKey, action.keyValue),
        deletewidgetflag: false
      };
    case types.ADD_SAMPLE_WIDGET:
      let trdColumns = JSON.parse(localStorage.getItem('defaultTradeBookColumns'))
      return {
        ...state,
        tradeBookColumns : trdColumns,
        dashboardWidgets: addWidgetSample(action.widget, action.layoutAdd),
        loadTempFlag: false
      };
    case types.IS_CMDTY_SELECTED:
      return {
        ...state,
        isCmdtySelected: action.isCmdtySelected
      };
    case types.HIDE_POPOUT:
      return {
        ...state,
        showPopup: false,
        internalServerError: false
      };
    case types.SESSION_TIMEOUT:
      return {
        ...state,
        sessionTimeOut: isSessionTimeOut(401)
      };
    case types.LOAD_TEMPLIST:
      return {
        ...state
      };
    case types.LOAD_TEMPLIST_SUCCESS:
      return {
        ...state,
        tempList: gettemplist(action.result.data.N)
      };
    case types.LOAD_TEMPLIST_FAILURE:
      return {
        ...state
      };
    case types.UPDATE_TRADEBOOK_COLUMNS:
      localStorage.setItem('tradeBookColumns', JSON.stringify(action.updatedTrdCols));
      return {
        ...state,
        tradeBookColumns: action.updatedTrdCols
      };
    case types.LAYOUT_CHANGE_STATUS:
      const ChangedData = action.layoutCount;
      if (ChangedData > 0) {
        return {
          ...state,
          changeLayoutFlag: 1
        };
      };
      return {
        ...state
      };
    case types.UPDATE_CAN_LOGOUT:
      return {
        canLogout: false
      };
    case types.HANDLE_SETTING_MODAL:
      return {
        ...state,
        settingmodal: action.status
      };
    case types.SAVE_SETTING:
      localStorage.setItem('isDefAccChngeFlag', "true");
      return {
        ...state,
        isDefAccChngeFlag : true,
      }
    case types.SAVE_SETTING_SUCCESS:
      const accMap = JSON.parse(localStorage.getItem('TS')).ACD;
      const tsData = JSON.parse(localStorage.getItem('TS'));
      tsData.isTrdInstant = action.initialState.isTrdInstant;
      tsData.storetradeqty = action.initialState.storetradeqty;
      tsData.showStock = action.initialState.showStockPrc;
      if (action.initialState.classname === 'smallerfont') {
        localStorage.setItem('fontsize', 'smallerfont');
        tsData.isSmallerfont = true;
        tsData.isBiggerfont = false;
        tsData.isNormalfont = false;

      }
      else if (action.initialState.classname === 'biggerfont') {
        localStorage.setItem('fontsize', 'biggerfont');
        tsData.isBiggerfont = true;
        tsData.isSmallerfont = false;
        tsData.isNormalfont = false;

      }
      else {
        localStorage.setItem('fontsize', 'Normalfont');
        tsData.isNormalfont = true;
        tsData.isBiggerfont = false;
        tsData.isSmallerfont = false;
      }

      var obj = {};
      accMap.map(item => {
        item.DFA = "0"; 
        if (item.C === action.result.data.DefAcc) {
          item.DFA = "1"; 
          obj = { 'AC': item.C, 'AD': item.D, 'isForward':item.isFwdEnable,  'isSwpEnable': item.isSwpEnable, 'maxTenor': item.maxTenor };
          localStorage.setItem('DefaultAC', JSON.stringify(obj));
        }
      })
      tsData.ACD = accMap;
      localStorage.setItem('TS', JSON.stringify(tsData));
      localStorage.setItem('isDefAccChngeFlag', "false");
      return {
        ...state,
        defAcc: obj,
        isDefAccChngeFlag: false,
        settingmodal: false,
        isTrdInstant: action.initialState.isTrdInstant,
        storetradeqty: action.initialState.storetradeqty,
        showStockPrc: action.initialState.showStockPrc,
        fontsize: action.initialState.classname,
        updatedAccBal: action.result.data.accBal,   
      }
    case types.SAVE_SETTING_FAILURE:
      return {
        ...state,
      }
    case types.LOAD_TEMPLATE:
      return {
        ...state,
        tradeBookColumns: action.layout.tradeBookData,
        layout: action.layout.tmplData,
        layoutWindow: action.layout.tmplData,
        dashboardWidgets: action.layout.tmplData,
        deleteWidgetKey: []
      };
    case types.DELETE_TEMPLATE:
      return {
        ...state,
      };
    case types.DELETE_TEMPLATE_SUCCESS:
      var randomNo = Math.floor((Math.random() * 100) + 1);
      return {
        ...state,
        deleteTempRandomNo: randomNo
      };
    case types.DELETE_TEMPLATE_FAILURE:
      return {
        ...state,
      };
    case types.HANDLE_BM_MODAL:
      return {
        ...state,
        BMModel: action.BMpopup
      }
    case types.HANDLE_LMT_MODAL:
      return {
        ...state,
        LMTModel: action.LMTPopup
      }
    case types.CHANGE_ADDWIDGETFLAG:
      return {
        ...state,
        addWidgetmodal: action.addWidgetmodal,
      }
    case types.HANDLE_LAYOUT_FLAGMODAL:
      return {
        ...state,
        enableflag: action.status
      };
    case types.LOAD_TEMP_FLAG:
      return {
        ...state,
        loadTempFlag: action.flag
      };
    case types.CHANGE_COMMDTY:
      var randomNo = Math.floor((Math.random() * 10000) + 1);
      return {
        ...state,
        layout: changeId(action.cmdyPair, action.currentId, action.layout, action.key),
        cmdtyPair: action.cmdyPair,
        cmdtyRandomNo: randomNo
      };
    case types.CHANGE_CHART_COMMDTY:
      var randomNo = Math.floor((Math.random() * 10000) + 1);
      return {
        ...state,
        layout: changeChartOpts(action.cmdyPair, action.currentId, action.layout, action.chartData),
        chartCmdtyPair: action.cmdyPair,
        chartCmdtyRandomNo: randomNo
      };
    case types.ENABLE_TOOLTIP:
      return {
        ...state,
        toolTipFlag: action.flag
      };
    case types.CHANGE_LMTORD_FLAG:
      return {
        ...state,
        lmtOrdComponentFlag: action.flag
      };
    case types.CHANGE_BMKORD_FLAG:
      return {
        ...state,
        bmkComponentFlag: action.flag
      };
    case types.CLEAR_SAVE_TEMP_MSG:
      return {
        ...state,
        saveTemplateFlag: action.flag
      };
    case types.IS_INITIAL_API_LOADED:
      return {
        ...state,
        isInitialApiLoaded: action.flag
      }
    case types.RESET_DASH_STATE:
      return initialState;

    default:
      return state;
  }
}
